// Accept any function shape that maps a key to a string — both react-intl's
// strongly-typed `TFunc` and a plain `(string) => string` test stub need to fit.
type TFn = (key: any) => string;

const PAIR_TO_KEY: Record<string, string> = {
  'TMS|Get Vehicle Information': 'eventType.cameraScan',
  'Arrival|Confirm Location': 'eventType.located',
  'Arrival|New Arrival': 'eventType.newArrival',
  'Arrival|Used Arrival': 'eventType.usedArrival',
  'Arrival|Update Tracking Label': 'eventType.trackingLabelUpdated',
  'Inspection|FPR Inspection': 'eventType.fprInspection',
  'Inspection|Mechanical Inspection': 'eventType.mechanicalInspection',
  'Inspection|Return Inspection Damage Detail':
    'eventType.returnInspectionDamage',
  'Inspection|Return Inspection Vehicle Detail':
    'eventType.returnInspectionVehicle',
};

export const categoryLabel = (
  t: TFn,
  category: string,
  subCategory: string,
): string => {
  const key = PAIR_TO_KEY[`${category}|${subCategory}`];
  return key ? t(key) : subCategory || category;
};
